import { ClientFormatMoneyPriceWrapperProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/ClientFormatMoneyPriceWrapperProps";
import { showProductPromotions } from "@faire/deprecated-retailer-visitor-shared/lib/showProductPromotions";
import { PRICE_TEXT_SURFACE } from "@faire/deprecated-retailer-visitor-shared/views/product/Price/PriceProps";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

export const productTilePriceAdapter = (
  productTile: ILeanProductTile,
  isLoggedIn: boolean
): ClientFormatMoneyPriceWrapperProps => {
  return {
    min_option_wholesale_price: productTile.min_option_wholesale_price,
    min_option_wholesale_promo_price:
      productTile.min_option_wholesale_promo_price,
    min_option_retail_price: productTile.min_option_retail_price,
    showProductPromotions: showProductPromotions(
      productTile.min_option_wholesale_promo_price
    ),
    small: true,
    isLoggedInOrBrandPreview: isLoggedIn,
    isTilePricing: true,
    priceTextSurface: PRICE_TEXT_SURFACE.PRODUCT_TILE,
  };
};
